import { ILogger } from '@cian/logger';

import { EExceptionDomain } from '../../types/exceptionDomains';
import { getGenericLikeError } from '../logging/getGenericLikeError';

const DEFAULT_EXCEPTION_MESSAGE = 'Ошибка при парсинге контекста кастомного чата';

export function getCustomChatContext(context: string | null | undefined, logger: ILogger) {
  try {
    if (!context) {
      return undefined;
    }

    return JSON.parse(window.atob(context));
  } catch (error) {
    const errorToLog = getGenericLikeError({
      error,
      domain: EExceptionDomain.Chat,
      message: DEFAULT_EXCEPTION_MESSAGE,
    });

    logger.warning(errorToLog, { context });

    return undefined;
  }
}
